export default __webpack_public_path__ + "8942a624cc83c7149dbe73feee0143a8.svg";